
import RowItem from '@/components/detail/row_item/index.vue'
import RowWrap from '@/components/detail/row_wrap/index.vue'
import FileList from '@/components/file_list/index.vue'
import { Component, Vue } from 'vue-property-decorator'
import { MediaService } from '@/services'
import { StatusMap, StatusPlain } from './config/report'

@Component({
    name: 'report-detail',
    components: {
        RowItem,
        RowWrap,
        FileList
    }
})
export default class extends Vue {
    private isLoading = true
    private detailId = ''
    private statusOption = StatusPlain
    private changeLoading = false
    private detail = {
        medium: {},
        user: {},
        title: '',
        status: 0,
        annexes: []
    }
    private created() {
        this.$title('Loading | 详情页 - 庖丁')
        this.detailId = this.$route.params.id
    }

    private async mounted() {
        this.isLoading = true
        await this.getDetail()
        this.isLoading = false
    }

    get matchStatus() {
        const statusItem = StatusMap.get(this.detail.status)
        return statusItem ? statusItem.value : ''
    }

    private matchButtonType(status: number) {
        return this.detail.status === status ? 'primary' : 'default'
    }

    /** 修改申请的信息 */
    private async getDetail() {
        const params = {
            id: +this.detailId
        }
        const result = await MediaService.getReportDetail(params)
        if (result.status === 200) {
            this.detail = result.data
            this.$title(`${this.detail.title} | 报料详情 - 庖丁`)
        }
    }

}
